import { CssBaseline } from '@mui/material'
import { StyledEngineProvider } from '@mui/styled-engine'
import Loadable from 'app/components/Loadable/Loadable'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { lazy } from 'react'
import 'react-chat-elements/dist/main.css'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import App from './app/App'
import './config/firebase'
import './index.css'
import * as serviceWorker from './serviceWorker'
import './wdyr.js'
// Lazy load ViewOrder component
const ViewOrder = Loadable(
    lazy(() => import('./app/views/viral/layouts/Layouts'))
)

ReactDOM.render(
    <StyledEngineProvider injectFirst>
        <BrowserRouter basename="/admin">
            <Routes>
                {' '}
                {/* Use Routes to wrap Route components */}
                {/* Define routes here */}
                <Route path="/showOrder" element={<ViewOrder />} />
            </Routes>
            <CssBaseline />
            <App />
        </BrowserRouter>
        <BrowserRouter basename="/">
            <Routes>
                {' '}
                {/* Use Routes to wrap Route components */}
                {/* Define routes here */}
                <Route path="/" element={<ViewOrder />} />
            </Routes>
            <CssBaseline />
            <App />
        </BrowserRouter>
    </StyledEngineProvider>,
    document.getElementById('root')
)

serviceWorker.unregister()
